import _get from 'lodash.get';
import { applySnapshot } from 'mobx-state-tree';

import fetchSavedDocumentDetails from './fetchSavedDocumentDetails';
import getDocumentDefinitionByPath from './getDocumentDefinitionByPath';


async function waitForDocumentUpdateUntil(
    document,
    path,
    callback,
    { interval = 1000, timeout = 10000 } = {},
) {
    if (!document || typeof document !== 'object') {
        throw new Error('[waitForDocumentUpdateUntil] Please specify proper document');
    }

    if (typeof path !== 'string') {
        throw new Error('[waitForDocumentUpdateUntil] Please specify proper path');
    }

    if (typeof callback !== 'function') {
        throw new Error('[waitForDocumentUpdateUntil] Please specify proper callback');
    }

    // Start polling
    return await _waitForDocumentUpdate(document, path, callback, interval, timeout);
}

async function _waitForDocumentUpdate(document, path, callback, interval, remainingTime) {
    const startTime = Date.now();

    const { id } = document;
    const { documents: fetchedDocuments } = await fetchSavedDocumentDetails([ {
        id,
        documentType: getDocumentDefinitionByPath(path).TYPE,
    } ]);
    const snapshot = _get(fetchedDocuments, `${path}.${id}`) ?? {};

    if (callback(snapshot)) {
        applySnapshot(document, snapshot);
        return;
    }

    await sleep(interval);

    const endTime = Date.now();
    remainingTime -= endTime - startTime;

    if (remainingTime > 0) {
        await _waitForDocumentUpdate(document, path, callback, interval, remainingTime);
    } else {
        throw new Error('[waitForDocumentUpdateUntil] Max time reached');
    }
}

async function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export default waitForDocumentUpdateUntil;
